export const FCM_FOREGROUND_EVENT = "seevi-fcm-foreground";

export type FcmForegroundMessage = {
  id: string;
  title: string;
  body: string;
  imageUrl?: string;
  data?: Record<string, string>;
};

export function parseFcmPayload(payload: any): FcmForegroundMessage {
  const title = payload?.notification?.title || payload?.data?.title || "SeeVi";
  const body = payload?.notification?.body || payload?.data?.body || "";
  const imageUrl = payload?.notification?.image || payload?.data?.image;
  const data = payload?.data as Record<string, string> | undefined;

  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    title,
    body,
    imageUrl,
    data,
  };
}

export function emitForegroundFcmMessage(payload: any): void {
  const message = parseFcmPayload(payload);
  window.dispatchEvent(
    new CustomEvent(FCM_FOREGROUND_EVENT, {
      detail: message,
    })
  );
}
